import { useAuthStore } from '@/features/auth/stores/AuthStore'
import { usePermissions } from '@/features/auth/components/Usepermissions'
import { defaultRouteByRole, allowedWebRoles } from '@/router/helpers/menu.config'

export function authGuard(to, from, next) {
  const authStore = useAuthStore()
  const { canAccess, loaded } = usePermissions()

  const requiresAuth  = to.meta?.requiresAuth
  const requiresGuest = to.meta?.requiresGuest

  if (authStore.isAuthenticated && !allowedWebRoles.has((authStore.role || '').toUpperCase())) {
    next(false)
    authStore.logout()
    return
  }

  if (requiresAuth && !authStore.isAuthenticated) {
    return next({ path: '/auth/login', query: { redirect: to.fullPath } })
  }

  if (requiresGuest && authStore.isAuthenticated) {
    const role = authStore.role
    const redirect = defaultRouteByRole[role] || '/app/dashboard'
    return next({ path: redirect })
  }

  if (to.path === '/') {
    const role = authStore.role
    const redirect = defaultRouteByRole[role] || '/app/dashboard'
    return next({ path: authStore.isAuthenticated ? redirect : '/auth/login' })
  }

if (to.meta?.roles) {
  const role = authStore.role
  if (!to.meta.roles.includes(role)) {
    const fallback = defaultRouteByRole[role] || '/app/dashboard'
    if (fallback !== to.path) return next({ path: fallback })
  }
}

if (to.meta?.menuResource) {
  if (!loaded.value) {
    return next()
  }
  if (!canAccess('MENU', to.meta.menuResource)) {
    const role = authStore.role
    const fallback = defaultRouteByRole[role] || '/app/dashboard'
    if (fallback !== to.path) return next({ path: fallback })
  }
}

  next()
}